import state from './state';
import Store from '../../base';

export default class PositionCategories extends Store {
    constructor(model, ng) {

        state.model = model;

        super({state, ng});
    }
}


// WEBPACK FOOTER //
// ./src/app/store/billing/position_categories/index.js